import { Layout } from "components"
export const DeviceSetting = () => {
 return (
  <Layout>
   <h1 className="flex justify-center py-5 text-xl font-bold">Device Setting</h1>
  </Layout>
 )
}
